React = require 'react'
createReactClass = require 'create-react-class'
PropTypes = require 'prop-types'
{ FormatCurrency } = require 'react-globalize'
Money = require "app/common/money"

toLocalDateTime = (date, locale) ->
  date.toLocaleString()

parseDateTime = (dateString) ->
  new Date Date.parse(dateString)

# locale is not required as it is using the restaurantStore locale
toMoney = (cents, locale = null) ->
  <Money cents={cents} locale={locale} />

module.exports =
  toLocalDateTime: toLocalDateTime
  parseDateTime: parseDateTime
  toMoney: toMoney
